import React, { Component } from 'react';
import axios from '~/axios';
import moment from 'moment';
import { Button, Select, Row, Col } from 'antd';
import Utility from '~/components/_global/Utility'
import { SITE_NAMES, SITES } from '~/constants/sites';

import AddSessionForm from '~/components/sessions/AddSessionForm';
import EditSessionForm from '~/components/sessions/EditSessionsForm';
import SessionsTable from '~/components/sessions/SessionsTable';
import ByDateSessionsTable from '~/components/sessions/ByDateSessionsTable';

class Sessions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: '',
            startTime: '',
            endTime: '',
            courses: [{ 0: { courseID: 1 } }],
            optionalFields: [],
            validationErrors: {},
            showAddSessionForm: false,
            showEditSessionForm: false,
            sessions: [],
            sessionEditID: undefined,
            byDaySite: 'LGH',
            byDayDateOptions: [],
            byDaySessions: [],
            loadingByCourse: false,
            loadingByDate: false,
            selectedCourse: '',
            hidePassedSessions: true
        }
        this.showAddSessionForm = this.showAddSessionForm.bind(this);
        this.hideAddSessionForm = this.hideAddSessionForm.bind(this);
        this.showEditSessionForm = this.showEditSessionForm.bind(this);
        this.hideEditSessionForm = this.hideEditSessionForm.bind(this);
        this.handleAddSession = this.handleAddSession.bind(this);
        this.handleEditSession = this.handleEditSession.bind(this);
        this.handleRemoveSession = this.handleRemoveSession.bind(this);
        this.handleFilterSessions = this.handleFilterSessions.bind(this);
        this.saveFormRef = this.saveFormRef.bind(this);
        this.editFormRef = this.editFormRef.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    /**
     * Shows the 'Add Session' form.
     */
    showAddSessionForm() {
        this.setState({ showAddSessionForm: true });
    }

    /**
     * Hides the 'Add Session' form.
     */
    hideAddSessionForm() {
        this.setState({ showAddSessionForm: false });
    }

    /**
     * Creates a new session.
     */
    handleAddSession() {
        const form = this.formRef.props.form;
        // console.log(form);
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            // console.log(values);
            let dateString = values.date.format('YYYY-MM-DD') + ' ';
            values.startTime = dateString + values.startTime.format('HH:mm:ss');
            values.endTime = dateString + values.endTime.format('HH:mm:ss');
            values.deadline = values.deadline.format('YYYY-MM-DD HH:mm:ss');
            try {
                axios.post('/api/sessions', values).then(response => {
                    this.handleChange(values.course);
                    form.resetFields();
                    this.setState({ showAddSessionForm: false });
                });
            } catch ( error ) {
                console.dir(error);
            }
        });
    }

    /**
     * Shows the 'Edit Session' form.
     * @param id {number} - The ID of the course to get sessions for.
     */
    showEditSessionForm(id) {

        this.setState({ sessionEditID: id });
        const form = this.editForm.props.form;
        // console.log(form.getFieldsValue());
        let session = this.state.sessions.find(element => {
            return element.sessionID === id;
        });

        form.setFieldsValue({
            courseID: session.course.courseID,
            site: session.site,
            date: moment(session.startTime),
            startTime: moment(session.startTime),
            endTime: moment(session.endTime),
            location: session.location,
            capacity: session.capacity,
            // Don't set key for deadline if the session's deadline is falsy (null, undefined, etc)
            [session.deadline ? "deadline" : ""]: session.deadline ? moment(session.deadline) : undefined,
        })

        this.setState({ showEditSessionForm: true });
    }

    /**
     * Hides the 'Edit Session' form.
     */
    hideEditSessionForm() {
        this.setState({ showEditSessionForm: false });
    }

    /**
     * Edits a specific session from this component's state.
     */
    handleEditSession() {
        // console.log("handling editSession");
        const sessionID = this.state.sessionEditID;
        const form = this.editForm.props.form;

        form.validateFields((err, values) => {

            if (err) {
                return;
            }
            let dateString = values.date.format('YYYY-MM-DD') + ' ';
            values.startTime = dateString + values.startTime.format('HH:mm:ss');
            values.endTime = dateString + values.endTime.format('HH:mm:ss');
            values.deadline = values.deadline.format('YYYY-MM-DD HH:mm:ss');
            try {
                axios.patch('/api/sessions/' + sessionID, values).then(response => {
                    this.handleChange(response.data.courseID);
                    form.resetFields();
                    this.setState({ showEditSessionForm: false });
                });
            } catch ( error ) {
                console.dir(error);
            }
        });
    }

    componentDidMount() {
        axios.get("api/courses", {
            params: {
                onlyActive: true
            }
        }).then(response => {
            this.setState({ courses: response.data });
        }).catch(error => {
            console.error(error);
        });

        // Retrieve dates for the default site, LGH
        this.getDatesForSite(SITES.LGH);
    }

    saveFormRef(formRef) {
        this.formRef = formRef;
    }

    editFormRef(formRef) {
        this.editForm = formRef;
    }

    /**
     * Retrieves a course's sessions when a course is selected.
     * @param value {number} - The ID of the course to get sessions for.
     */
    handleChange(value) {
        this.setState({ loadingByCourse: true, selectedCourse: value });
        console.log("handleChange(" + value + ")");
        axios.get('/api/course/' + value + '/sessions', {
            params: {
                hidePassedSessions: this.state.hidePassedSessions
            }
        }).then(response => {
            console.log(response);
            this.setState({ sessions: response.data.data, loadingByCourse: false });
        }).catch(function (error) {
            console.dir(error);
        });
    }

    /**
     * Get dates on which sessions are scheduled for a specific site.
     *
     * @param {string} site - The site to get dates for.
     */
    getDatesForSite(site) {
        this.setState({ byDaySite: site });
        console.log(site)
        Utility.getDatesForSite(site).then(data => {
            this.setState({ byDayDateOptions: data });
        });
    }

    /**
     * Get the sessions for a specific site on a specific date.
     *
     * @param {string} site - The site to get sessions for.
     * @param {string} date - The date to get sessions for.
     */
    getSessionsForSiteDate(site, date) {
        this.setState({ loadingByDate: true });
        Utility.getSessionsForSiteDate(site, date).then(data => {
            console.log(data)
            this.setState({ byDaySessions: data, loadingByDate: false });
        });
    }

    /**
     * Removes a specific session from this component's state.
     *
     * @param sessionID {number} - The ID of the session to remove.
     */
    handleRemoveSession(sessionID) {
        let sessions = this.state.sessions;
        let index = sessions.findIndex(element => {
            return element.sessionID === sessionID;
        });
        sessions.splice(index, 1);
        this.setState({ sessions: sessions });
    }

    /**
     * Filters sessions by selected filter
     *
     * @param value {string} - The new filter string
     */
    handleFilterSessions(value) {
        console.log(value)

        let hidePassedSessions = undefined;
        if (value.date && value.date[0] === 'showAll') {
            console.log("show all the seessions!")
            hidePassedSessions = false;
        } else if (value.date && value.date[0] === 'hideOldSessions') {
            console.log("hide old sessions")
            hidePassedSessions = true;
        } else {
            console.log("filter error")
        }
        // If hidePassedSession has been updated, set state and refresh sessions
        if (hidePassedSessions !== undefined) {
            this.setState({ hidePassedSessions: hidePassedSessions }, () => {
                console.log(this.state.hidePassedSessions)
                this.handleChange(this.state.selectedCourse);
            });
        }

    }

    render() {
        let courseOptions = [];
        this.state.courses.forEach((object, key) => {
            courseOptions.push(<Select.Option key={ key } value={ object.courseID }>{ object.title }</Select.Option>)
        });
        let byDayDateOptions = [];
        this.state.byDayDateOptions.forEach((object, key) => {
            byDayDateOptions.push(<Select.Option key={ key } value={ object }>{ object }</Select.Option>)
        });
        return (<div>
            <h1>Sessions</h1>
            <Row>
                <h2>by course</h2>
                <Row>
                    <Col span={ 12 }>
                        <Select value={ this.state.selectedCourse } style={ { width: '100%' } }
                                onChange={ this.handleChange }>
                            { courseOptions }
                        </Select>
                    </Col>
                    <Col span={ 12 }>
                        <Button type="primary" onClick={ this.showAddSessionForm } style={ { float: 'right' } }>Add a
                            session</Button>
                    </Col>
                </Row>
                <SessionsTable loading={ this.state.loadingByCourse } sessions={ this.state.sessions }
                               showEditSessionForm={ this.showEditSessionForm }
                               handleRemoveSession={ this.handleRemoveSession }
                               handleFilterSessions={ this.handleFilterSessions }/>
            </Row>

            <Row>
                <h2>by date</h2>
                <Row>
                    <Col span={ 6 }>
                        <Select style={ { width: '100%' } } onChange={ this.getDatesForSite.bind(this) }
                                defaultValue={ SITES.LGH }>
                            { Object.entries(SITE_NAMES).map(([SITE_VALUE, SITE_NAME]) => {
                                return (<Select.Option key={ SITE_VALUE }
                                                       value={ SITE_VALUE }>{ SITE_NAME }</Select.Option>)
                            }) }
                        </Select>
                    </Col>
                    <Col span={ 6 }>
                        <Select style={ { width: '100%' } }
                                onChange={ this.getSessionsForSiteDate.bind(this, this.state.byDaySite) }>
                            { byDayDateOptions }
                        </Select>
                    </Col>
                </Row>
                <Row>
                    <ByDateSessionsTable loading={ this.state.loadingByDate } sessions={ this.state.byDaySessions }
                                         showEditSessionForm={ this.showEditSessionForm }
                                         handleRemoveSession={ this.handleRemoveSession }/>
                </Row>
            </Row>

            <AddSessionForm
                wrappedComponentRef={ this.saveFormRef }
                visible={ this.state.showAddSessionForm }
                onCancel={ this.hideAddSessionForm }
                onOk={ this.handleAddSession }
                courses={ this.state.courses }
                selectedCourse={ this.state.selectedCourse }
            />

            <EditSessionForm
                id={ this.state.sessionEditID }
                wrappedComponentRef={ this.editFormRef }
                visible={ this.state.showEditSessionForm }
                onCancel={ this.hideEditSessionForm }
                onOk={ this.handleEditSession }
                courses={ this.state.courses }
            />
        </div>);
    }
}

export default Sessions;
